import __request__ from "routing/request";
export function listConfiguredProviders(query, sort = "provider", order = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.llm/model-provider/configured", null, { "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function createConfiguredProvider(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.llm/model-provider/configured", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getConfiguredProvider(provider, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.llm/model-provider/configured/${provider}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateConfiguredProvider(provider, request, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.llm/model-provider/configured/${provider}`, request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function deleteConfiguredProvider(provider, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.llm/model-provider/configured/${provider}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setDefaultProvider(provider, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.llm/model-provider/configured/${provider}/default`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
